export default __webpack_public_path__ + "static/media/kn.0372da95.jpg";